(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cymoom-outfit-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cymoom-outfits')) {
    customElements.define('cymoom-outfits', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.co-track');
        this.posts = [...this.querySelectorAll('[data-post]')];
        this.dataset.input = 'pointer';
        document.addEventListener('pointerdown', () => { this.dataset.input = 'pointer'; }, { ...options, capture: true });
        document.addEventListener('keydown', event => {
          if (['Tab', 'Enter', ' ', 'Escape', 'ArrowLeft', 'ArrowRight'].includes(event.key)) this.dataset.input = 'keyboard';
        }, { ...options, capture: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-open')) this.open(button.dataset.open, button);
          if (button.hasAttribute('data-close')) this.close();
          if (button.hasAttribute('data-post-direction')) this.move(Number(button.dataset.postDirection));
          if (button.hasAttribute('data-scroll')) {
            this.track.scrollBy({ left: Number(button.dataset.scroll) * this.track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }
        }, options);
        this.posts.forEach(post => {
          post.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
          post.addEventListener('close', () => { if (this.active === post) this.finishClose(); }, options);
          post.addEventListener('click', event => {
            const rect = post.getBoundingClientRect();
            if (event.target === post && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.close();
          }, options);
          post.addEventListener('keydown', event => {
            if (event.target.closest('input, textarea, select, summary, .co-products')) return;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              this.move(event.key === 'ArrowLeft' ? -1 : 1);
            }
          }, options);
        });
        document.addEventListener('shopify:block:select', event => {
          const post = this.posts.find(item => item.dataset.post === event.detail?.blockId);
          if (post) this.open(post.dataset.post, this.querySelector('[data-open="' + post.dataset.post + '"]'));
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.target.contains(this)) this.close();
        }, options);
      }
      open(id, trigger) {
        const post = this.posts.find(item => item.dataset.post === id);
        if (!post || this.active === post) return;
        if (!this.active) {
          this.trigger = trigger || document.activeElement;
          this.overflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
        } else {
          const previous = this.active;
          this.active = null;
          previous.close();
        }
        this.active = post;
        post.showModal();
        post.scrollTop = 0;
        post.querySelector('[data-close]').focus({ preventScroll: true });
      }
      move(direction) {
        if (!this.active || this.posts.length < 2) return;
        const index = (this.posts.indexOf(this.active) + direction + this.posts.length) % this.posts.length;
        this.open(this.posts[index].dataset.post);
      }
      close() {
        if (!this.active) return;
        this.active.close();
        this.finishClose();
      }
      finishClose() {
        if (!this.active) return;
        this.active = null;
        document.documentElement.style.overflow = this.overflow;
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.close();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cymoom-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cymoom-popup')) {
    customElements.define('cymoom-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const applyTextSizes = () => {
          const sizes = {
            '.cp-intro': this.dataset.introSize,
            '.cp-offer-text': this.dataset.offerSize,
            '.cp-email-heading': this.dataset.emailHeadingSize,
            '.cp-success-heading': this.dataset.successHeadingSize,
            '.cp-success-copy': this.dataset.successCopySize
          };
          Object.entries(sizes).forEach(([selector, size]) => {
            if (size) this.querySelectorAll(selector).forEach(element => {
              element.style.setProperty('--ct-size', size, 'important');
              element.style.setProperty('font-size', 'var(--ct-size)', 'important');
            });
          });
        };
        new MutationObserver(applyTextSizes).observe(this, { attributes: true, attributeFilter: ['data-intro-size', 'data-offer-size', 'data-email-heading-size', 'data-success-heading-size', 'data-success-copy-size'], childList: true, subtree: true });
        applyTextSizes();
        this.dataset.focusMode = 'pointer';
        document.addEventListener('pointerdown', () => {
          this.dataset.focusMode = 'pointer';
        }, { ...options, capture: true });
        document.addEventListener('keydown', event => {
          if (['Tab', 'Enter', ' ', 'Escape', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
            this.dataset.focusMode = 'keyboard';
          }
        }, { ...options, capture: true });
        this.dialog = this.querySelector('dialog');
        this.teaser = this.querySelector('.cp-teaser');
        this.form = this.querySelector('form');
        this.preview = this.dataset.preview === 'true';
        this.key = 'cymoom-popup:' + this.dataset.campaign;
        this.step = 'offer';
        this.complete = false;
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
        this.querySelector('[data-next]').addEventListener('click', () => this.setStep('email', true), options);
        this.querySelector('[data-open]').addEventListener('click', () => this.open(), options);
        this.querySelector('[data-hide-teaser]').addEventListener('click', () => {
          this.teaser.hidden = true;
          this.save('sessionStorage', this.key + ':hidden', '1');
        }, options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dismiss();
        }, options);
        this.dialog.addEventListener('close', () => this.unlock(), options);
        this.form.addEventListener('submit', () => {
          this.save('sessionStorage', this.key + ':pending', String(Date.now()));
        }, options);
        const pending = Number(this.read('sessionStorage', this.key + ':pending'));
        const ours = (pending > 0 && Date.now() - pending < 1800000) || location.hash === '#' + this.form.id;
        const result = this.querySelector('[data-result]');
        if (result && ours) {
          this.save('sessionStorage', this.key + ':pending', '');
          if (result.dataset.result === 'success') {
            this.complete = true;
            this.save('localStorage', this.key + ':complete', '1');
            this.setStep('success');
          } else {
            this.setStep('email');
          }
          this.open();
          return;
        }
        if (this.preview) {
          this.open();
          return;
        }
        if (this.dataset.subscriber === 'true' || this.read('localStorage', this.key + ':complete') === '1') return;
        const dismissed = Number(this.read('localStorage', this.key + ':dismissed'));
        if (dismissed > 0 && Date.now() - dismissed < Number(this.dataset.days) * 86400000) {
          this.teaser.hidden = this.read('sessionStorage', this.key + ':hidden') === '1';
        } else {
          this.timer = setTimeout(() => this.open(), Number(this.dataset.delay));
        }
      }
      read(storage, key) {
        try { return window[storage].getItem(key); } catch (_) { return null; }
      }
      save(storage, key, value) {
        if (this.preview) return;
        try { window[storage].setItem(key, value); } catch (_) {}
      }
      setStep(step, focus = false) {
        this.step = step;
        this.querySelectorAll('[data-step]').forEach(panel => { panel.hidden = panel.dataset.step !== step; });
        if (focus) this.querySelector('[data-step="' + step + '"] input, [data-step="' + step + '"] button')?.focus();
      }
      open() {
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.teaser.hidden = true;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        this.dialog.showModal();
        const target = this.step === 'email' ? this.querySelector('.cp-errors') || this.querySelector('.cp-email') : this.querySelector('[data-close]');
        target?.focus({ preventScroll: true });
      }
      dismiss() {
        clearTimeout(this.timer);
        this.save('localStorage', this.key + ':dismissed', String(Date.now()));
        this.teaser.hidden = this.complete;
        this.dialog.close();
        this.unlock();
        if (!this.complete) this.querySelector('[data-open]').focus({ preventScroll: true });
        else if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      unlock() {
        if (!this.locked) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.dialog?.open) this.dialog.close();
        this.unlock();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cymoom-tipografia"]) return;
  try {
    
(() => {
  const levels = 'h1,h2,h3,h4,h5,h6,p,.h1,.h2,.h3,.h4,.h5,.h6,.paragraph';
  const excluded = 'script,style,textarea,select,svg,math,code,pre,.icon,[data-typography-keep],[data-cymoom-text-shift],[contenteditable]:not([contenteditable="false"]),cymoom-font-editor';
  function wrapText(root) {
    if (!root.isConnected) return;
    const nodes = [];
    if (root.nodeType === Node.TEXT_NODE) nodes.push(root);
    else {
      if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) nodes.push(walker.currentNode);
    }
    for (const node of nodes) {
      const parent = node.parentElement;
      if (!node.textContent.trim() || !parent || parent.closest(excluded) || !parent.closest(levels)) continue;
      const span = document.createElement('span');
      span.setAttribute('data-cymoom-text-shift', '');
      node.replaceWith(span);
      span.appendChild(node);
    }
  }
  function start() {
    // Wrappers contain text only, keeping backgrounds, controls and layout fixed.
    wrapText(document.body);
    const observer = new MutationObserver(records => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'characterData') roots.add(record.target);
        else for (const node of record.addedNodes) roots.add(node);
      }
      for (const root of roots) wrapText(root);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
